import { supabase } from '@/lib/supabase'
import type { AffiliateUplineChildOverview, AffiliateUplineCommissionRow } from '../types'

export async function getAffiliateUplineChildren(parentAffiliateId: string): Promise<AffiliateUplineChildOverview[]> {
  if (!parentAffiliateId) return []
  const { data, error } = await supabase
    .from('v_affiliate_upline_children_overview')
    .select(
      'parent_affiliate_id, child_affiliate_id, child_name, child_email, child_code, upline_total_cents, upline_30d_cents, upline_commissions_count',
    )
    .eq('parent_affiliate_id', parentAffiliateId)
    .order('child_name', { ascending: true })
  if (error) throw error
  return (data as any[]) || []
}

export async function listAffiliateUplineCommissionsByChild(
  parentAffiliateId: string,
  childAffiliateId: string,
  page = 1,
  pageSize = 25,
): Promise<{ rows: AffiliateUplineCommissionRow[]; total: number }> {
  if (!parentAffiliateId || !childAffiliateId) return { rows: [], total: 0 }
  const from = Math.max(0, (page - 1) * pageSize)
  const to = Math.max(0, from + pageSize - 1)
  const { data, error, count } = await supabase
    .from('v_affiliate_upline_commissions_detailed')
    .select(
      'parent_affiliate_id, child_affiliate_id, commission_id, account_id, subscription_id, amount_cents, currency, status, period_start, period_end, matures_at, matured_at, paid_at, payout_id, reason, void_reason',
      { count: 'exact' },
    )
    .eq('parent_affiliate_id', parentAffiliateId)
    .eq('child_affiliate_id', childAffiliateId)
    .order('period_end', { ascending: false })
    .range(from, to)
  if (error) throw error
  return {
    rows: ((data as any[]) || []) as any,
    total: Number(count || 0),
  }
}

